const status = state => state.feedback.status;

export default {
  status,
};
